// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Layout from "./components/common/Layout";
// import Home from "./pages/Home";
// import Login from "./pages/Login";
// import Buildings from "./pages/Buildings/Index";
// import ForgotPassword from "./pages/ForgotPassword";
// import ResetPassword from "./pages/ResetPassword";
// import CreateBuilding from "./pages/Buildings/CreateBuilding";
// import BuildingDetails from "./pages/Buildings/BuildingDetails";
// import MyTeam from "./pages/MyTeam/Index";
// import AddTeam from "./pages/MyTeam/AddTeam";
// import ImportData from "./pages/ImportData";

// function App() {
//   return (
//     <Router>
//       <Layout>
//         <Routes>
//           <Route path="/" element={<Navigate to="/login" replace />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/reset-password/:token" element={<ResetPassword />} />
//           <Route path="/dashboard" element={<Home />} />
//           <Route path="/buildings" element={<Buildings />} />
//           <Route path="/buildings/create-building" element={<CreateBuilding />} />
//           <Route path="/buildings/edit/:id" element={<CreateBuilding />} />
//           <Route path="/buildings/building-details/:id" element={<BuildingDetails />} />
//           <Route path="/my-team" element={<MyTeam />} />
//           <Route path="/my-team/add" element={<AddTeam />} />
//           <Route path="/my-team/edit/:id" element={<AddTeam />} />
//           <Route path="/import-data" element={<ImportData />} />
//         </Routes>
//       </Layout>
//     </Router>
//   );
// }

// export default App;


import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/common/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Buildings from "./pages/Buildings/Index";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateBuilding from "./pages/Buildings/CreateBuilding";
import BuildingDetails from "./pages/Buildings/BuildingDetails";
import MyTeam from "./pages/MyTeam/Index";
import AddTeam from "./pages/MyTeam/AddTeam";
import ImportData from "./pages/ImportData";
import ImportedDataList from "./pages/ImportedDataList";
import CreateKey from "./pages/CreateKey";
import Keys from "./pages/Keys";
import Calculations from "./pages/Calculations";
import ResultII from "./pages/ResultII";
import Reports from "./pages/Reports/Index";
import KeyDiagram from "./pages/Reports/KeyDiagram";
import AllKeyDiagrams from "./pages/Reports/AllKeyDiagrams";
import RepartitionReportIndex from "./pages/RepartitionReport/Index";
import RepartitionReportPreview from "./pages/RepartitionReport/Preview";
import MyProfile from "./pages/MyAccount/MyProfile";
import ChangePassword from "./pages/MyAccount/ChangePassword";

// Example auth utility
const getUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user;
  } catch {
    return {};
  }
};

// Protected Route Wrapper
const ProtectedRoute = ({ children, allowedAccess }) => {
  const user = getUser();

  if (!user?.token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedAccess && !allowedAccess.includes(user.access_level)) {
    return <Navigate to="/dashboard" replace />; // redirect if no permission
  }

  return children;
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Dashboard (accessible by all logged-in users) */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <Home />
              </ProtectedRoute>
            }
          />

          {/* Buildings (accessible by both access levels) */}
          <Route
            path="/buildings"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <Buildings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buildings/create-building"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <CreateBuilding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buildings/edit/:id"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <CreateBuilding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/buildings/building-details/:id"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <BuildingDetails />
              </ProtectedRoute>
            }
          />

          {/* My Team (Full access only, access_level = 1) */}
          <Route
            path="/my-team"
            element={
              <ProtectedRoute allowedAccess={[1]}>
                <MyTeam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-team/add"
            element={
              <ProtectedRoute allowedAccess={[1]}>
                <AddTeam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-team/edit/:id"
            element={
              <ProtectedRoute allowedAccess={[1]}>
                <AddTeam />
              </ProtectedRoute>
            }
          />

          {/* Import Data (accessible by both access levels) */}
          <Route
            path="/import-data"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <ImportData />
              </ProtectedRoute>
            }
          />

          {/* Imported Data Lists (accessible by both access levels) */}
          <Route
            path="/imported-data/:type"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <ImportedDataList />
              </ProtectedRoute>
            }
          />

          {/* Keys Management (Full access only, access_level = 1) */}
          <Route
            path="/keys"
            element={
              <ProtectedRoute allowedAccess={[1]}>
                <Keys />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-key"
            element={
              <ProtectedRoute allowedAccess={[1]}>
                <CreateKey />
              </ProtectedRoute>
            }
          />

          {/* Calculations (accessible by both access levels) */}
          <Route
            path="/calculations"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <Calculations />
              </ProtectedRoute>
            }
          />

          <Route
            path="/result-ii"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <ResultII />
              </ProtectedRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/:id"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <KeyDiagram />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/all"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <AllKeyDiagrams />
              </ProtectedRoute>
            }
          />

          {/* Répartition report (Phase 3) — selector page + placeholder preview.
              The real PDF renderer replaces the preview component in C1a. */}
          <Route
            path="/repartition-report"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <RepartitionReportIndex />
              </ProtectedRoute>
            }
          />
          <Route
            path="/repartition-report/preview"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <RepartitionReportPreview />
              </ProtectedRoute>
            }
          />

          {/* My Account */}
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute allowedAccess={[1, 2]}>
                <ChangePassword />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
